var ApiCall = {
  PING: "Ping",
  PING_LEGACY: "ping",
  LOGIN: "LoginUser",
  LOGOUT: "LogoutUser",
  GET_MY_IP: "GetMyIP",
  ONLINE_RESET_USER_PASSWORD: "OnlineResetUserPassword",
  INVOKE_GET_METHOD: "InvokeGetMethod",
  INVOKE_METHOD: "InvokeMethod",
  VALIDATE_USER_SESSION: "ValidateLocalSession",
  GET_EMAIL_CONFIG: "GetEmailConfig",
  UPDATE_EMAIL_CONFIG: "UpdateEmailConfig",
  GET_SYSTEM_PREFERENCES_RACING: "GetSystemPreferencesRacing",
};

export default ApiCall;
